import React from 'react';
import PropTypes from 'prop-types';
import { sortApiRoutes } from '../../helpers/helpers';
import { NavLink } from 'react-router-dom';

import RouteLink from './RouteLink';

class CategoryLink extends React.PureComponent {
	shouldComponentUpdate(nextProps) {
		return this.props.isSelected || nextProps.isSelected;
	}
	render() {
		const { category, isSelected } = this.props;
		const sorted = sortApiRoutes(category.routes);
		return (
			<div className="category-link nav-link">

				<NavLink to={`/api/${category.name}`}>
					{category.name}
				</NavLink>

				{isSelected &&
					<div className="route-links">
						{
							sorted.map(route => <RouteLink key={`${route.verbs[0]}-${route.name}`} route={route} />)
						}
					</div>
				}

			</div>
		);
	}
}

CategoryLink.propTypes = {
	category: PropTypes.object.isRequired,
	hash: PropTypes.string,
	isSelected: PropTypes.bool.isRequired
};

export default CategoryLink;


// WEBPACK FOOTER //
// ./src/components/api/CategoryLink.js